import React, { Component } from 'react';

class ActivityBar extends Component {
  render() {
    const current = this.props.current;
    return (
      <div className="activity-bar">
        <ul className="activity-bar__icon-list">
          <li className={current === 'normal' ? 'activity-bar__item--active' : null} onClick={() => {this.props.switcher('normal')}}><i className="fa fa-circle-o activity-bar__normal-icon"></i></li>
          <li className={current === 'contrast' ? 'activity-bar__item--active' : null} onClick={() => {this.props.switcher('contrast')}}><i className="fa fa-moon-o activity-bar__contrast-icon"></i></li>
          <li className={current === 'light' ? 'activity-bar__item--active' : null} onClick={() => {this.props.switcher('light')}}><i className="fa fa-sun-o activity-bar__light-icon"></i></li>
        </ul>
      </div>
    );
  }
}

export default ActivityBar;



// WEBPACK FOOTER //
// ./src/components/ActivityBar.js